import { render, staticRenderFns } from "./FeatureSetup.vue?vue&type=template&id=15f5d39f&scoped=true"
import script from "./FeatureSetup.vue?vue&type=script&lang=ts"
export * from "./FeatureSetup.vue?vue&type=script&lang=ts"
import style0 from "./FeatureSetup.vue?vue&type=style&index=0&id=15f5d39f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5d39f",
  null
  
)

export default component.exports